// extracted by mini-css-extract-plugin
export default {"container":"CK-z","topReviewHeading":"DK-z","criticalReview":"EK-z","favorableReview":"FK-z","vsSeparator":"GK-z"};